import React, { useState } from "react"
import { useSelector } from "react-redux"

import Images from "assets/images"
import { MtAccount } from "server/models"
import {
    StoreType,
    AccountPackageList,
} from "client/store"
import { Logo, Expired } from "client/components"
import {
    SuccessfulAuthWrapper,
    AuthTitle,
    AccountListWrapper,
    AccountList,
    AccountItem,
    AccountInfo,
    AccountName,
    ConfirmAccount,
} from "./styled"

interface SelectAccountProps {
    show: boolean
    setUserData: (account: MtAccount) => void
}

const SelectAccount = ({
    show = false,
    setUserData = null,
}: SelectAccountProps) => {
    const [selectedAccount, setSelectedAccount] = useState(null)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const accountList = useSelector((state: StoreType) => state.account.accountList)
    const accountIds = useSelector((state: StoreType) => state.account.accountIds)
    const accountPackageList = useSelector((state: StoreType) => state.accountPackage.accountPackageList) as AccountPackageList
    const now = new Date()

    return (
        <SuccessfulAuthWrapper show={show}>
            <AuthTitle>{lang.selectAccount}</AuthTitle>
            <AccountListWrapper>
                <AccountList>
                    {
                        accountIds && accountIds.map((id) => {
                            const account = accountList[id]
                            const demoExpiry = account.demoExpiry ? new Date(account.demoExpiry) : null
                            const demoExpired = demoExpiry && demoExpiry < now

                            const accountPackage = accountPackageList && accountPackageList[id] && accountPackageList[id].length
                                ? accountPackageList[id][0]
                                : null
                            const packageExpiry = accountPackage ? new Date(accountPackage.dateEnd) : null
                            const packageExpired = packageExpiry && packageExpiry < now

                            return (
                                <AccountItem
                                    key={account.id}
                                    active={account.id === selectedAccount}
                                    onClick={() => {
                                        if (selectedAccount === account.id) {
                                            if (demoExpired) return
                                            setUserData(account)
                                        } else {
                                            setSelectedAccount(account.id)
                                        }
                                    }}
                                >
                                    <Logo
                                        size={60}
                                        borderRadius={16}
                                        logo={account.logo || Images.accountLogo}
                                    />
                                    <AccountInfo>
                                        <AccountName>{account.name}</AccountName>
                                        {
                                            demoExpired && <Expired>{lang.demoExpired}</Expired>
                                        }
                                        {
                                            !demoExpired && packageExpired && <Expired>{lang.packageExpired}</Expired>
                                        }
                                        {
                                            !demoExpired && (
                                                <ConfirmAccount show={selectedAccount === account.id}>
                                                    {lang.clickConfirm}
                                                </ConfirmAccount>
                                            )
                                        }
                                    </AccountInfo>
                                </AccountItem>
                            )
                        })
                    }
                </AccountList>
            </AccountListWrapper>
        </SuccessfulAuthWrapper>
    )
}
export default SelectAccount
